<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="pr-2 pl-2">
        <b-row>
          <b-col
            v-if="selectedMode.mode === viewModeKanban"
            cols="12"
            md="5"
            class="d-flex align-items-center justify-content-start mt-1 mb-1"
          >
            <b-row class="w-100">
              <b-col
                cols="12"
                md="6"
              >
                <phase-select
                  id="phase"
                  v-model="filterOptions.phase_set"
                  class="w-100 mb-0"
                  :required-field="selectedMode.mode === viewModeKanban"
                  @ready="syncLoad.ready('phase')"
                />
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  label="Buscar na Tabela"
                  label-for="idSearchBox"
                  class="mb-0"
                >
                  <b-form-input
                    id="idSearchBox"
                    v-model.lazy="filterOptions.search"
                    placeholder="Buscar"
                    type="text"
                    class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            v-if="selectedMode.mode === viewModeTable"
            cols="12"
            md="5"
            class="d-flex align-items-center justify-content-start mt-1 mb-1"
          >
            <div>
              <b-form-group
                label="Exibir Linhas"
                label-for="idPerPage"
                class="mb-0"
              >
                <v-select
                  id="idPerPage"
                  v-model="pageSize"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block"
                >
                  <span slot="no-options">Não há opções para essa quantidade.</span>
                </v-select>
              </b-form-group>
            </div>
            <div class="ml-1 w-100">
              <b-form-group
                label="Buscar na Tabela"
                label-for="idSearchBox"
                class="mb-0"
              >
                <b-form-input
                  id="idSearchBox"
                  v-model.lazy="pageSearch"
                  placeholder="Buscar"
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </div>
            <div
              class="d-flex align-items-center justify-content-center"
            >
              <div>
                <b-dropdown
                  id="idDropdownSelectColumns"
                  class="dropBtnTableToolbar mt-2 ml-50"
                  variant="link"
                  no-caret
                  :dropup="true"
                  offset="-150"
                  :boundary="'scrollParent'"
                >

                  <template #button-content>
                    <b-button
                      v-b-tooltip.hover
                      class="btn-icon rounded-circle"
                      variant="flat-primary"
                      size="md"
                      title="Exibir colunas"
                    >
                      <svg-icon
                        type="mdi"
                        size="22"
                        :path="mdiTableEdit"
                      />
                    </b-button>
                  </template>
                  <b-dropdown-text
                    class="showColumnsDropdown"
                  >
                    Exibir Colunas
                  </b-dropdown-text>

                  <b-dropdown-divider />
                  <b-dropdown-form>
                    <b-form-checkbox
                      v-for="(column, index) in ajustableFields"
                      :key="index"
                      v-model="tableColumns[column.index].visible"
                      :value="true"
                      :unchecked-value="false"
                      class="mb-1"
                    >
                      {{ column.label }}
                    </b-form-checkbox>
                  </b-dropdown-form>

                </b-dropdown>
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mt-1 mb-1 px-0"
          >
            <div
              v-if="filterSaved"
              class="d-flex align-items-center justify-content-center"
            >
              <div>
                <b-dropdown
                  id="idBtnDropdownFilter"
                  :text="filterOptions.id !== '' ? getFilterName() : 'Meus Filtros'"
                  class="mt-2 w-100"
                  variant="outline-primary"
                >
                  <b-dropdown-item
                    v-for="(obj, index) in filterList"
                    v-show="filterList.length > 0"
                    :key="index"
                    @click="selectFilter(index)"
                  >
                    <svg-icon
                      class="mr-1"
                      type="mdi"
                      size="18"
                      :path="(filterOptions.id === obj.id ) ? mdiCircle : mdiCircleOutline"
                    />
                    {{ obj.name }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-show="filterList.length === 0"
                  >
                    Não existem filtros cadastrados
                  </b-dropdown-item>
                  <b-dropdown-divider />
                  <b-dropdown-item
                    v-show="filterList.length > 0"
                    @click="clearFilter()"
                  >
                    Sem Filtro
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-center mt-2 ml-1"
            >
              <div>
                <b-button
                  v-b-tooltip.hover
                  class="btn-icon rounded-circle"
                  variant="primary"
                  size="sm"
                  title="Filtro Avançado"
                  @click="toggleFilter()"
                >
                  <svg-icon
                    type="mdi"
                    size="20"
                    :path="mdiFilterPlusOutline"
                  />
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-end mt-1 mb-1"
          >
            <div
              class="d-flex align-items-center justify-content-center mt-1 ml-1"
            >
              <div v-if="kanbanEnable">
                <b-button
                  v-b-tooltip.hover
                  class="btn-icon rounded-circle"
                  :variant="selectedMode.mode === viewModeKanban ? 'flat-primary' : 'flat-info'"
                  title="Visualização Modo Kanban"
                  @click="selectViewMode(viewModeKanban)"
                >
                  <svg-icon
                    type="mdi"
                    size="24"
                    :path="mdiViewColumnOutline"
                  />
                </b-button>
              </div>
              <div v-if="tableEnable">
                <b-button
                  v-b-tooltip.hover
                  class="btn-icon rounded-circle"
                  :variant="selectedMode.mode === viewModeTable ? 'flat-primary' : 'flat-info'"
                  title="Visualização Modo Tabela"
                  @click="selectViewMode(viewModeTable)"
                >
                  <svg-icon
                    type="mdi"
                    size="24"
                    :path="mdiViewListOutline"
                  />
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div
        v-show="isFilterOpen"
        class="filterOptionsForm p-2"
      >
        <b-row>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-top justify-content-end"
          >
            <div class="w-100">
              <b-row>
                <b-col
                  cols="12"
                  md="3"
                >
                  <phase-select
                    id="phase"
                    v-model="filterOptions.phase_set"
                    :required-field="selectedMode.mode === viewModeKanban"
                    @ready="syncLoad.ready('phase')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <status-select
                    id="status"
                    v-model="filterOptions.status_set"
                    :filter-phase="filterOptions.phase_set"
                    @ready="syncLoad.ready('status')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <interest-select
                    id="interest"
                    v-model="filterOptions.interest_set"
                    @ready="syncLoad.ready('interest')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <owner-select
                    id="owner"
                    v-model="filterOptions.owner_set"
                    @ready="syncLoad.ready('owner')"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  md="3"
                >
                  <b-form-group
                    label="Data de Início"
                    label-for="dateStart"
                  >
                    <b-form-datepicker
                      id="dateStart"
                      v-model="filterOptions.date_start"
                      locale="pt-BR"
                      size="md"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      label-no-date-selected="Nenhuma data foi selecionada"
                      selected-variant="primary"
                      placeholder="Selecione uma data"
                      label-help="Use o teclado ou o mouse para navegar pelas datas do calendário"
                      :reset-button="selectedMode.mode === viewModeTable"
                      :reset-value="''"
                      reset-button-variant="info"
                      label-reset-button="Limpar"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <b-form-group
                    label="Data de Término"
                    label-for="dateFinish"
                  >
                    <b-form-datepicker
                      id="dateFinish"
                      v-model="filterOptions.date_finish"
                      locale="pt-BR"
                      size="md"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      label-no-date-selected="Nenhuma data foi selecionada"
                      selected-variant="primary"
                      placeholder="Selecione uma data"
                      label-help="Use o teclado ou o mouse para navegar pelas datas do calendário"
                      :reset-button="selectedMode.mode === viewModeTable"
                      :reset-value="''"
                      reset-button-variant="info"
                      label-reset-button="Limpar"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <company-select
                    id="company"
                    v-model="filterOptions.company_set"
                    @ready="syncLoad.ready('company')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <client-select
                    id="client"
                    v-model="filterOptions.client_set"
                    @ready="syncLoad.ready('client')"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  md="3"
                >
                  <platform-select
                    id="platform"
                    v-model="filterOptions.platform_set"
                    @ready="syncLoad.ready('platform')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <modality-select
                    id="modality"
                    v-model="filterOptions.modality_set"
                    @ready="syncLoad.ready('modality')"
                  />
                </b-col>
                <b-col
                  v-if="typeEnable"
                  cols="12"
                  md="3"
                >
                  <type-select
                    id="type"
                    v-model="filterOptions.type_set"
                    @ready="syncLoad.ready('type')"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="3"
                >
                  <imported-select
                    id="imported"
                    v-model="filterOptions.imported"
                    @ready="syncLoad.ready('imported')"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  cols="12"
                  md="3"
                >
                  <is-filed-select
                    id="isFiled"
                    v-model="filterOptions.is_filed"
                    @ready="syncLoad.ready('is_filed')"
                  />
                </b-col>
              </b-row>
            </div>
            <div class="ml-1">
              <b-button
                v-if="(filterOptions.id !== '') && (hasPermissionToWrite)"
                v-b-tooltip.hover
                class="btn-icon rounded-circle"
                variant="flat-info"
                title="Remover Filtro"
                @click="confirmDeleteFilter()"
              >
                <svg-icon
                  type="mdi"
                  size="18"
                  :path="mdiTrashCanOutline"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="hasPermissionToWrite && buttonsEnable"
        >
          <b-col
            class="d-flex justify-content-end buttonsSaveCancel"
          >
            <b-button
              class="filterBtn mr-auto"
              variant="outline-primary"
              @click="exportFilter()"
            >
              <svg-icon
                type="mdi"
                size="22"
                :path="mdiFileExportOutline"
              />
              Exportar Dados Filtrados
            </b-button>
            <b-button
              class="filterBtn"
              variant="primary"
              @click="saveFilter()"
            >
              Salvar
            </b-button>
            <b-button
              class="filterBtn ml-1"
              variant="outline-primary"
              @click="cancelFilter()"
            >
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <validation-observer
      v-slot="{ handleSubmit, invalid }"
      ref="refFormObserver"
    >
      <b-modal
        id="idModalFilter"
        ref="refModalFilter"
        no-close-on-backdrop
        no-close-on-esc
        centered
        cancel-variant="outline-primary"
        :ok-disabled="invalid"
        @ok="handleSubmit(submit)"
      >
        <template #modal-title>
          Cadastro de Filtro
        </template>
        <template #modal-cancel>
          Cancelar
        </template>
        <template #modal-ok>
          Salvar
        </template>
        <b-form
          class="mt-1"
        >
          <b-row>
            <b-col>
              <validation-provider
                #default="validationContext"
                name="name"
                :rules="{
                  required: true,
                }"
              >
                <b-form-group
                  label="Nome"
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    v-model="filterOptions.name"
                    name="name"
                    placeholder="Nome"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BDropdownText,
  BDropdownForm,
  BDropdownDivider,
  BForm,
  BFormInput,
  BFormGroup,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormDatepicker,
  BModal,
  VBTooltip,
} from 'bootstrap-vue'

import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

import {
  mdiTableEdit,
  mdiFilterPlusOutline,
  mdiViewListOutline,
  mdiViewColumnOutline,
  mdiCircle,
  mdiCircleOutline,
  mdiFileExportOutline,
  mdiTrashCanOutline,
} from '@mdi/js'

import {
  useToast,
} from 'vue-toastification/composition'

import moment from 'moment'
import vSelect from 'vue-select'
import SvgIcon from '@jamescoyle/vue-icon'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import truncate from '@/components/utils/filters/truncate'
import SyncLoad from '@/components/utils/syncLoad'
import MetaData from '@/components/utils/metaData'
import CompanySelect from '@/components/company/CompanySelect.vue'
import ClientSelect from '@/components/client/ClientSelect.vue'
import ImportedSelect from '@/components/bidding/ImportedSelect.vue'
import IsFiledSelect from '@/components/bidding/IsFiledSelect.vue'
import InterestSelect from '@/components/bidding/InterestSelect.vue'
import ModalitySelect from '@/components/bidding/ModalitySelect.vue'
import PlatformSelect from '@/components/bidding/PlatformSelect.vue'
import TypeSelect from '@/components/bidding/TypeSelect.vue'
import StatusSelect from '@/components/bidding/StatusSelect.vue'
import PhaseSelect from '@/components/bidding/PhaseSelect.vue'
import OwnerSelect from '@/components/user/OwnerSelect.vue'
import syslic from '@/syslic'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BDropdownForm,
    BDropdownDivider,
    BForm,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormDatepicker,
    BModal,
    SvgIcon,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    CompanySelect,
    ClientSelect,
    ImportedSelect,
    IsFiledSelect,
    InterestSelect,
    ModalitySelect,
    PlatformSelect,
    TypeSelect,
    StatusSelect,
    PhaseSelect,
    OwnerSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  filters: {
    truncate,
  },
  props: {
    perPage: {
      type: Number,
      required: false,
      default: 10,
    },
    perPageOptions: {
      type: Array,
      required: false,
      default: () => [10, 25, 50, 100],
    },
    visibleColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    kanbanEnable: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonsEnable: {
      type: Boolean,
      required: false,
      default: true,
    },
    tableEnable: {
      type: Boolean,
      required: false,
      default: true,
    },
    typeEnable: {
      type: Boolean,
      required: false,
      default: true,
    },
    typePreset: {
      type: [Object, String],
      required: false,
      default: '',
    },
    filterSaved: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ['ready'],

  data() {
    const filterEmpty = {
      id: '',
      name: '',
      page_size: this.perPage,
      search: '',
      company_set: '',
      client_set: '',
      platform_set: '',
      owner_set: '',
      modality_set: '',
      type_set: '',
      phase_set: '',
      status_set: '',
      interest_set: '',
      date_start: '',
      date_finish: '',
      imported: {
        label: 'Importadas & Não Importadas',
        value: null,
      },
      is_filed: {
        label: 'Não Arquivadas',
        value: false,
      },
    }

    const statusDefault = {}
    const filterList = []

    const filterOptions = JSON.parse(JSON.stringify(filterEmpty))

    const tableColumns = []

    const isLoading = true
    const syncLoad = new SyncLoad()
    syncLoad.addTrigger('filter')

    if (this.typeEnable) {
      syncLoad.addTrigger('type')
    }

    syncLoad.addTrigger('modality')
    syncLoad.addTrigger('platform')
    syncLoad.addTrigger('client')
    syncLoad.addTrigger('company')
    syncLoad.addTrigger('owner')
    syncLoad.addTrigger('imported')
    syncLoad.addTrigger('interest')
    syncLoad.addTrigger('status')
    syncLoad.addTrigger('status_default')
    syncLoad.addTrigger('phase')
    syncLoad.addTrigger('is_filed')

    syncLoad.onReady(() => {
      this.isLoading = false
      this.$emit('ready', true)
    })

    const isFilterOpen = false
    const viewModeTable = 'viewModeTable'
    const viewModeKanban = 'viewModeKanban'
    const selectedMode = {
      mode: viewModeTable,
    }

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(this.value)

    const meta = new MetaData('BiddingFilter')

    return {
      refFormObserver,
      getValidationState,
      statusDefault,
      filterOptions,
      filterList,
      filterEmpty,
      tableColumns,
      syncLoad,
      isLoading,
      isFilterOpen,
      selectedMode,
      viewModeTable,
      viewModeKanban,
      meta,
    }
  },
  computed: {
    pageSize: {
      get() {
        return this.filterOptions.page_size
      },
      set(value) {
        this.filterOptions.page_size = value
        this.refreshFilter()
      },
    },
    pageSearch: {
      get() {
        return this.filterOptions.search
      },
      set(value) {
        this.filterOptions.search = value
        this.refreshFilter()
      },
    },
    ajustableFields() {
      const fields = []
      this.tableColumns.forEach((element, index) => {
        if (!element.fixedColumn) {
          fields.push({
            index,
            label: element.label,
          })
        }
      })

      return fields
    },
    hasPermissionToWrite() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.bidding.can_write
    },
  },
  watch: {
    tableColumns: {
      handler: function updateColumns(val) {
        this.$emit('columns-change', val)
      },
      deep: true,
    },
    filterOptions: {
      handler: function updateFilter() {
        this.refreshFilter()
      },
      deep: true,
    },
    selectedMode: {
      handler: function updateViewMode(val) {
        this.$emit('viewmode-change', val.mode)
      },
      deep: true,
    },
    typePreset: {
      handler: function updateType() {
        this.refreshFilter()
      },
      deep: true,
    },
  },
  created() {
    this.tableColumns = this.visibleColumns

    this.filterOptions = this.meta.bind(this.filterOptions, 'filterOptions')
    this.tableColumns = this.meta.bind(this.tableColumns, 'tableColumns')
    this.selectedMode = this.meta.bind(this.selectedMode, 'selectedMode')

    this.loadFilters()
    this.loadStatus()
  },
  methods: {
    refreshFilter() {
      if (this.checkDate()) {
        const filter = this.getFilter(this.filterOptions)
        this.$emit('filter-change', filter)
      }
    },
    exportFilter() {
      this.$emit('export-filter')
    },
    loadStatus() {
      syslic
        .bidding
        .status
        .fetchAllStatusBasic()
        .then(response => {
          const statusList = response.data.results

          statusList.forEach(element => {
            if (element.initial) {
              this.statusDefault = element
            }
          })

          if (this.selectedMode.mode === this.viewModeKanban) {
            if (this.filterOptions.id === '') {
              this.filterOptions.phase_set = this.statusDefault.phase_set
            }
          }
          this.syncLoad.ready('status_default')
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados do servidor.',
              text: 'Não foi possível ler os dados do servidor, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.syncLoad.ready('status_default')
        })
    },
    loadFilters() {
      syslic
        .bidding
        .filter
        .fetchFilters()
        .then(response => {
          if (response.data.results.length > 0) {
            this.filterList = response.data.results
          }
          this.syncLoad.ready('filter')
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados.',
              text: 'Não foi possível ler os dados do servidor, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.syncLoad.ready('filter')
        })
    },
    checkDate() {
      let valid = true
      if (this.filterOptions.date_start && this.filterOptions.date_finish) {
        if (this.filterOptions.date_start > this.filterOptions.date_finish) {
          valid = false
          this.$swal({
            title: 'Atenção!',
            text: 'A data de término não pode ser anterior a data de início.',
            icon: 'warning',
            showConfirmButton: false,
            timer: 4000,
          })
        }
      }
      return valid
    },
    getFilter(val) {
      const filter = {
        id: val.id,
        name: val.name,
        search: val.search,
        page_size: val.page_size,
        client: '',
        platform: '',
        owner: '',
        modality: '',
        type: '',
        phase: '',
        status: '',
        interest: '',
        imported: null,
        is_filed: null,
      }

      if (val.date_start) {
        filter.date_start = val.date_start
      }

      if (val.date_finish) {
        filter.date_finish = val.date_finish
      }

      if (val.client_set) {
        filter.client = val.client_set.id
      }

      if (val.platform_set) {
        filter.platform = val.platform_set.id
      }

      if (val.owner_set) {
        filter.owner = val.owner_set.id
      }

      if (val.modality_set) {
        filter.modality = val.modality_set.id
      }

      if (val.type_set) {
        filter.type = val.type_set.id
      }

      if (val.phase_set) {
        filter.phase = val.phase_set.id
      }

      if (val.status_set) {
        filter.status = val.status_set.id
      }

      if (val.interest_set) {
        filter.interest = val.interest_set.id
      }

      if (this.typePreset) {
        filter.type = this.typePreset.id
        filter.type_set = this.typePreset
      }

      if (val.imported !== null) {
        if (typeof val.imported.value === 'boolean') {
          filter.imported = val.imported.value
        }
      }

      if (val.is_filed !== null) {
        if (typeof val.is_filed.value === 'boolean') {
          filter.is_filed = val.is_filed.value
        }
      }

      return filter
    },
    clearFilter() {
      const { page_size, search } = this.filterOptions
      this.filterOptions = JSON.parse(JSON.stringify(this.filterEmpty))

      /* eslint camelcase: ["off"] */
      this.filterOptions.page_size = page_size
      this.filterOptions.search = search

      this.isFilterOpen = false
    },
    selectFilter(index) {
      const { page_size, search } = this.filterOptions

      this.filterOptions = JSON.parse(JSON.stringify(this.filterList[index]))

      /* eslint camelcase: ["off"] */
      this.filterOptions.page_size = page_size
      this.filterOptions.search = search
      this.setupViewMode()
    },
    getFilterName() {
      const stop = 25
      const text = this.filterOptions.name
      return text.slice(0, stop) + (stop < text.length ? '...' : '')
    },
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    selectViewMode(mode) {
      this.selectedMode.mode = mode
      this.clearFilter()
      this.setupViewMode()
    },
    setupViewMode() {
      if (this.selectedMode.mode === this.viewModeKanban) {
        if (this.filterOptions.phase_set === '' || this.filterOptions.phase_set === null) {
          this.filterOptions.phase_set = this.statusDefault.phase_set
          this.filterOptions.phase = this.statusDefault.phase_set.id
        }

        if (this.filterOptions.date_start === '') {
          this.filterOptions.date_start = moment().startOf('year').format('YYYY-MM-DD')
        }

        if (this.filterOptions.date_finish === '') {
          this.filterOptions.date_finish = moment().endOf('year').format('YYYY-MM-DD')
        }
      }
    },
    cancelFilter() {
      this.filterList.forEach((element, index) => {
        if (element.id === this.filterOptions.id) {
          this.selectFilter(index)
        }
      })
      this.toggleFilter()
      this.clearFilter()
    },
    saveFilter() {
      if (this.checkDate()) {
        this.$refs.refModalFilter.show()
      }
    },
    submit() {
      if (this.checkDate()) {
        const filter = this.getFilter(this.filterOptions)
        if (filter.id === '') {
          this.createFilter(filter)
        } else {
          this.updateFilter(filter)
        }
      }
    },
    createFilter(filter) {
      syslic
        .bidding
        .filter
        .addFilter(filter)
        .then(response => {
          this.filterList.push(response.data)
          this.selectFilter((this.filterList.length - 1))

          if (this.filterList[0].id === '') {
            this.filterList.splice(0, 1)
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Filtro adicionado com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(err => {
          let textError = 'Não foi possível criar o filtro, por favor entre em contato com o administrador do sistema.'

          if (err.data.name !== undefined) {
            if (err.data.name.includes('bidding filter with this name already exists.')) {
              textError = 'Não foi possível criar este filtro pois já existe um filtro cadastrado com o mesmo nome.'
            }
          }
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao criar filtro.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    updateFilter(filter) {
      syslic
        .bidding
        .filter
        .updateFilter(filter.id, filter)
        .then(response => {
          this.filterList.forEach((element, index) => {
            if (element.id === response.data.id) {
              this.filterList[index] = response.data
            }
          })

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Filtro atualizado com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(err => {
          let textError = 'Não foi possível atualizar o filtro, por favor entre em contato com o administrador do sistema.'

          if (err.data.name !== undefined) {
            if (err.data.name.includes('bidding filter with this name already exists.')) {
              textError = 'Não foi possível atualizar este filtro pois já existe um filtro cadastrado com o mesmo nome.'
            }
          }
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao atualizar filtro.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    deleteFilter() {
      syslic
        .bidding
        .filter
        .deleteFilter(this.filterOptions.id)
        .then(() => {
          this.filterList.forEach((obj, index) => {
            if (obj.id === this.filterOptions.id) {
              this.filterList.splice(index, 1)
            }
          })

          this.clearFilter()

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Filtro removido com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          const textError = 'Não foi possível remover o filtro, por favor entre em contato com o administrador do sistema.'

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao remover filtro.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    confirmDeleteFilter() {
      this.$bvModal
        .msgBoxConfirm('Por favor, confirme que você quer remover o filtro.', {
          id: 'confirmation_box',
          title: 'Confirmar?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-primary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteFilter()
          }
        })
    },
  },
  setup() {
    const toast = useToast()
    return {
      toast,
      moment,
      mdiTableEdit,
      mdiFilterPlusOutline,
      mdiViewListOutline,
      mdiViewColumnOutline,
      mdiCircle,
      mdiCircleOutline,
      mdiFileExportOutline,
      mdiTrashCanOutline,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.dropdownfix .dropdown.show {
  position: fixed;
}

.filterOptionsForm {
  background-color: #FAFAFC;
  border-top: 1px solid #d8d6de;
}

.filterBtn {
  min-width: 7.5rem;
}

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#idDropdownSelectColumns .btn.dropdown-toggle {
  padding: 0px !important;
}

#idBtnDropdownFilter {
  min-width: 20rem;
}

#idModalFilter .modal-footer {
  display: flex !important;
  flex-direction: row-reverse;

  justify-content: end;

  .btn{
    min-width: 107px;
  }
}

.buttonsSaveCancel{
  .btn{
    min-width: 107px;
  }
}
</style>
